import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './../layout';
import { getMail, saveMail ,  partnerApi, partnerCategory } from './../../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';

import Tabs from "../Tabs";
import TabsPane from "../Tabs/TabsPane";

import Overview from "./update_profile/overview_profile";
import Contact from "./update_profile/contact_profile";
import Documents from "./update_profile/document";
import Password_pro from "./update_profile/password_profile";
import Category_tab1 from "./update_profile/categoryv1";

class partnerProfile_new extends Component {

    constructor(props) {
        super(props);
        let qrystr = window.location.search;
        const urlParams = new URLSearchParams(qrystr);
        let sid = urlParams.get('sid');
        this.state = {
          auth_data: JSON.parse(localStorage.getItem("user_data")),
          is_completed: (localStorage.getItem("is_completed") ? localStorage.getItem("is_completed") : 0),
          plan_id: 0,
          user_type: 0,
          sid: sid != null ? sid : -1,
          page_name: '',
          category_list: []
        };
        this.getPageName();
        this.getMainCategory();
    }

    componentDidMount() {
        if (this.state.auth_data.current_plan != 0) {
        this.setState({
            plan_id: this.state.auth_data.current_plan
        });
        }
    }

    getPageName = () => {
        const { login_id, set_id } = this.state.auth_data;
        let sid = this.state.sid != -1 ? this.state.sid : set_id;
        if (sid != 0) {
        let req = JSON.stringify({
            role: 3,
            login_id: login_id,
            sid: this.state.sid != -1 ? this.state.sid : set_id,
            url: 'getPageName'
        });
        partnerApi(req).then(res => {
            if (res.status === 1) {
            let name = res.name;
            this.setState({
                page_name: name
            });
            }
        });
        }
    }

    getMainCategory = () => {
        let req = JSON.stringify({
        category_id: 0,
        user_type: this.state.auth_data.user_type,
        role: 3,
        url: 'categorydata'
        });
        partnerCategory(req).then(res => {
        if (res.status === 1) {
            this.setState({
            category_list: res.scategory_list
            })
        }
        });
    }


    render() {

    const { is_completed, auth_data } = this.state;      

    const childTabs = [
      
      {
        name: "Overview",
        id: "inst_deta",
        disabled: (this.state.sid == 0 ? true : false)
      },
      {
        name: "Contact Person Details",
        id: "contact",
        disabled: this.state.sid == 0 ? true : (is_completed == 0 ? true : false)
      },
     
      {
        name: "Change Password",
        id: "chan_pass",
        disabled: (this.state.sid == 0 ? true : false)
      },
      {
        name: `Category`,
        id: "category",
        defaultChecked: true,
      },
    ];
    if (auth_data.user_type == 2 && auth_data.isSubpartner == false) {
      console.log('***auth_data', auth_data)
      childTabs.push({
        name: "Documents",
        id: "docs",
      })
    }

    return (
        <React.Fragment>
            <AdminLayout>
                <div class="col-12 grid-margin">
                        <div class="card">
                            <div class="card-body">

                                <h4 class="card-title">Update Profile</h4>
                                
                                    <div class="mainblock">
                                        <Overview />
                                        <Contact />
                                       
                                        <Category_tab1 />
                                        <Documents />
                                    </div>

                                    <div class="pad50"><a href="/partner/accountinfonew" class="btn btn-primary">Proceed Next</a></div>

                            </div>
                        </div>
                </div>  
            </AdminLayout>
        </React.Fragment>
    )
    }
}

export default partnerProfile_new;


// WEBPACK FOOTER //
// ./src/components/bewise/partners/profileNew.jsx